$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // Email Signup
  if (window.location.pathname !== '/email.aspx') {
    const $emailSignup = $('.emailSignup');
    $emailSignup.find('.emailSubmitButton').text('SUBSCRIBE');
    $emailSignup.find('.inputFieldTextbox').val('');
    $emailSignup.find('.inputFieldTextbox')
      .attr('src', FULLCLIENTTHEMEPATH + 'images/email.png')
      .attr('placeholder', 'ENTER EMAIL');
    $emailSignup.find('.emailSignupText').html("NEWSLETTER!");
    $('.emailInputField, .emailInputSubmit').wrapAll('<div class="emailInputContainer"></div>');
  }

  // Ticket
  $('.ticket').text('');
  $('.ticket').attr('aria-label', 'Get Tickets');

  $(' a.ticket').text('');
  $('.a.ticket').attr('aria-label', 'Get Tickets');

  // Mobile Nav Ticket
  $('.mobile-menu-container .mobile-menu-ticket-btn').appendTo('.mobile-menu-header');
  $('.mobile-menu-cart').appendTo('.mobile-menu-header');
  $('.header-logo').clone().appendTo('.mobile-menu-header');
  $('.close-mobile-menu ').appendTo('.mobile-menu-header');

  // Append Follow Along
  $('.follow-along-text').appendTo('#socialNetworkWidget');

  // Move footer nav on mobile
  if ($('body').hasClass('saffireMobileSize')) {
    $('.footer .footer-navigation').appendTo('.footer .footer-top .inner .top-right');
  }

  // Feature Lineup
  $('.featureLineup-buynow .button').text('BUY NOW');
  $('.featureLineup-more .button').text('MORE');

  $('.featureLineup-text').each(function () {
    var text = $(this).text();
    if (text.length > 140) {
      $(this).text(text.substring(0, 140) + '...');
    }
  });

  $('.featureLineup-title').each(function () {
    var $this = $(this);
    var text = $this.text().trim();
    if (text.length > 35) {
      var truncatedText = text.substring(0, 35);
      $this.text(truncatedText);
    }
  });


  $(".featureLineupContainer").each(function() {
    var row_obj = this;
  var titles = $(row_obj).find('.subContainer').find('span.featureLineup-title').detach();
  var btns = $(row_obj).find('.featureLineup-buttons').find('.featureLineup-more').detach();
  var destext = $(row_obj).find('.featureLineupImage a:eq(1)').find('.featureLineup-text').detach();
  
  $(row_obj).find('.subContainer').find('.featureLineupImage').prepend(titles);
  $(row_obj).find('.subContainer').find('.featureLineupImage').prepend(destext);
  $(row_obj).find('.subContainer').find('.featureLineupImage').append(btns);
  });
});

let headerModified = false;

function changeHeaderLayout() {
  const siteInfoBanner = $('#siteInfoBannerWidget');
  const clonedWidget = $('#clonedSiteInfoBannerWidget');

  if (!headerModified && window.innerWidth <= 980) {
    // Append the siteInfoBanner to the mobile view container
    if (clonedWidget.length === 0) {
      const newClonedWidget = siteInfoBanner.clone();
      newClonedWidget.attr('id', 'clonedSiteInfoBannerWidget');
      newClonedWidget.addClass('mobile-countdown');
      $('.header-bottom .inner').append(newClonedWidget);

      // Splice the last 5 characters off the cloned widget's #eventDates
      const mobileEventDates = newClonedWidget.find('#eventDates');
      const mobileText = mobileEventDates.text();
      if (mobileText.length > 6) {
        mobileEventDates.text(mobileText.slice(0, -6));
      }
    }
    headerModified = true;
  } else if (headerModified && window.innerWidth > 980) {
    // Return the siteInfoBanner to its original position and remove the cloned widget
    clonedWidget.remove();
    headerModified = false;
  }
}

$(document).ready(() => {
  // Search
  function searchBoxPlaceholder() {
    const searchInput = $('#headerNav_uc_widgetContainer_ctl03_ctl00_SearchBox1_tbx_searchBox');
    searchInput.attr('placeholder', 'Type here...');
  }

  function modifySearchBox() {
    const searchInput = $('.searchBoxInput .inputFieldTextbox');
    searchInput.val('Search');

    searchInput.focus(() => {
      if (searchInput.val() === 'Search') {
        searchInput.val('');
      }
    });

    searchInput.blur(() => {
      if (searchInput.val() === '') {
        searchInput.val('Search');
      }
    });
  }
  searchBoxPlaceholder();
  modifySearchBox();
});

$(document).ready(() => {
  $(window).load(() => {
    setTimeout(() => {
      changeHeaderLayout();

      // Check and hide .main-right if no events
      function checkAndHideMainRight() {
        if ($('#multiScheduleFeature .featureItem').length === 0) {
          $('.main-right').css('display', 'none');
          $('.main-left').css({
            'width': '100%',
            'display': 'flex',
            'justify-content': 'center'
          });
          $('#swiperWidget').css('max-width', '800px'); 
        } else {
          $('.main-right').css('display', 'block');
          $('.main-left').css({
            'width': '',
            'display': '',
            'justify-content': ''
          });
          $('#swiperWidget').css('max-width', '');
        }
      }
      checkAndHideMainRight();

    }, 500);
  });

  $(window).resize(() => {
    changeHeaderLayout();
  });
});

$(window).load(function () {
  setTimeout(function () {
    // Hide extra instagram posts
    var instafeedContainer = $('#instafeedContainer');
    var links = instafeedContainer.find('a');

    if (links.length > 6) {
      links.slice(6).hide();
    }

    $('#instafeedContainer a').each(function () {
      $(this).find('img').css({
        'width': '45%',
        'height': '170px',
        'object-fit': 'cover'
      });
    });
  }, 500);
});